import React from 'react';
import { Tab } from '@components/atoms/Tab';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import { EmptyData } from '@components/molecules/EmptyData';
import { Card } from '@components/atoms/Card';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import { useHistory } from 'react-router';

interface AssignedProjectsProps {
  projects: {
    projectId: string;
    name: string;
    siteImage: string;
  }[];
}

export const AssignedProjects: React.FC<AssignedProjectsProps> = ({
  projects,
}) => {
  const history = useHistory();

  const gotToProject = (projectId: string) => {
    history.push(`/projects/${projectId}`);
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-4 mt-6 items-end">
        <Tab
          tabs={[
            {
              id: 'assignedProjects',
              name: 'Assigned Projects',
              leftIcon: <WorkOutlineIcon className="w-4 h-4" />,
              count: projects?.length || 0,
            },
          ]}
          activeTab=""
          onTabChange={() => {}}
        />
      </div>

      {projects.length === 0 && (
        <div className="min-h-60">
          <EmptyData description="No Assigned Projects" />
        </div>
      )}

      {projects.length > 0 &&
        projects.map((project) => (
          <Card
            key={project.projectId}
            className="flex gap-4 items-center cursor-pointer"
            onClick={() => gotToProject(project.projectId)}>
            <div className="flex justify-between">
              {project.siteImage ? (
                <img
                  alt={project.name}
                  src={project.siteImage || ''}
                  className="w-14 h-14 object-cover rounded-lg"
                />
              ) : (
                <div className="w-14 h-14 bg-gray-200 text-gray-500 dark:bg-gray-600 rounded-lg flex items-center justify-center">
                  <ImageOutlinedIcon sx={{ fontSize: '34px' }} />
                </div>
              )}
            </div>
            <p className="text-sm text-gray-900 dark:text-gray-100 break-all">
              {project.name}
            </p>
          </Card>
        ))}
    </div>
  );
};
